import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getFileList } from '../../redux/actions';
import { baseUrl } from '../../config';
import P404 from '../P404';
import MediaSingle from './MediaSingle';
import Player from './Player';
import audio from '../../config/audio.json';

const useStyles = makeStyles(theme => ({
  list: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    marginLeft: -5,
    marginRight: -5,
  },
}));

let lastFile = { name: '', url: '' };
let currentTime = 0;
const audioBaseUrl = `${baseUrl}/resources/Audio/`;

function Media(props) {
  const classes = useStyles();
  const { course, media } = props;
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState({ name: '', url: '' });
  const [status, setStatus] = useState('paused');
  const courseAudioUrl = `${audioBaseUrl}${course.id}/`;

  useEffect(() => {
    const { playing, waiting, ended, pause } = props.media.events;
    const playingSubscribtion = playing.subscribe(() => setStatus('playing'));
    const loadingSubscribtion = waiting.subscribe(() => setStatus('loading'));
    const endedSubscribtion = ended.subscribe(() => setStatus('ended'));
    const pausedSubscribtion = pause.subscribe(() => setStatus('paused'));
    return () => {
      playingSubscribtion.unsubscribe();
      loadingSubscribtion.unsubscribe();
      endedSubscribtion.unsubscribe();
      pausedSubscribtion.unsubscribe();
      currentTime = props.media.getAudioTime();
      stop();
    }
    // eslint-disable-next-lilne
  }, []);

  useEffect(() => {
    if (!props.files.id || props.files.id !== course.id) {
      course.id !== undefined && props.getFileList(course.id);
    } else {
      checkFiles();
    }
  }, [props.files, course]);

  const checkFiles = () => {
    const courseCDs = audio[course.id];
    if (!courseCDs) return;
    const files = [];
    courseCDs.forEach((cd) => {
      cd.audio.forEach((file) => {
        file.url = courseAudioUrl + cd.folder + '/' + file.file;
        files.push(file)
      });
    });
    setFiles(files);
  }

  const play = (file2) => {
    if (file2) {
      setFile(file2);
    } else {
      file2 = file;
    }
    const url = file2.url;
    media.play(url);
    lastFile = file2;
  }

  const stop = () => media.stop();

  const renderMp3 = () => {
    return files.map(f => {
      let newStatus = 'paused';
      if (f.file === file.file) {
        newStatus = status;
      }
      return <MediaSingle
        key={f.file}
        play={play}
        stop={stop}
        file={f}
        baseUrl={courseAudioUrl}
        status={newStatus}
      />
    }
    );
  }

  if (course.id === undefined) return <P404 />
  if (!props.files.id || props.files.id !== course.id) return '';

  return (
    <div className={classes.wrap}>
      <Player
        files={files}
        play={play}
        stop={stop}
        file={file}
        baseUrl={courseAudioUrl}
        status={status}
        setFile={setFile}
      />
      <div className={classes.list}>
        {renderMp3()}
        <div /><div /><div />
      </div>
    </div>
  );

}

const mapStateToProps = (state) => {
  return {
    files: state.files,
    config: state.config,
    media: state.media,
    course: state.course,
  };
}

export default connect(mapStateToProps, { getFileList })(Media);
